import type { LinkProps } from '@packages/shared';
import { useRouter } from 'next/router';
import type { CategoryNavigationItemSERP } from '../../api/rest/types';
import type { CategoryFilterItem } from '../CategoryFilterStandalone';

export const useSearchResultDataForCategoryFilter = (
  categories: CategoryNavigationItemSERP[],
): CategoryFilterItem[] => {
  const {
    pathname,
    query: { c, ...otherQueryParameters },
  } = useRouter();

  const generateCategoryHref = (categoryId: string) =>
    ({
      pathname,
      query: { ...otherQueryParameters, c: categoryId },
    }) as LinkProps['href'];

  return categories.map(({ id, name, level, count, isParentSelected, isSelected }) => ({
    id,
    name,
    level,
    count,
    href: generateCategoryHref(id),
    isSelected: isParentSelected || isSelected,
    isSelectedExact: isSelected,
  }));
};
